import { createSlice } from "@reduxjs/toolkit"

export const reqCategoryListSlice = createSlice({
	name: "reqCategory_list",
	initialState: {
		reqCategories: "",
		errors: [],
	},

	reducers: {
        getReqCategories: (state, action) => {
            // console.log(action.payload)
			state.reqCategories = action.payload
		},
		getRegCategoryList: (state, action) => {
			state.reqCategories = action.payload
		},
		getErrors: (state, action) => {
			state.errors = action.payload
		},
	},
})
export const {getReqCategories, getRegCategoryList, getErrors} = reqCategoryListSlice.actions

export default reqCategoryListSlice.reducer
